import './ProductDropdownTrigger.scss'

import CaretDown from 'icons/CaretDown'
import Dropdown from 'lib/components/Dropdown/Dropdown'
import ProductCategory, { getDisplayNameByCategory } from 'pages/Home/ProductCategory'
import React from 'react'
import { useTranslation } from 'react-i18next'

export interface ProductDropdownTriggerProps {
  currentProductCategory: ProductCategory
  onClick: ()=> void
}

export default function ProductDropdownTrigger(props: ProductDropdownTriggerProps): JSX.Element {
  const { currentProductCategory, ...otherProps } = props
  const [t] = useTranslation()
  const displayNameByCategory = getDisplayNameByCategory(t)

  return (
    <Dropdown.Trigger className="product-dropdown-trigger" {...otherProps}>
      <div>{displayNameByCategory[currentProductCategory]}</div>
      <div className="dropdown-icon">
        <CaretDown />
      </div>
    </Dropdown.Trigger>
  )
}
